class themeActivatelife {
	constructor() {
		this.handheldMenu();
		this.primaryMenu();
	}


	primaryMenu() {
		// Wait for DOM to be ready.
		var container = document.getElementById('site-navigation');
		if (!container) {
			return;
		}
		var menu = container.querySelector( 'ul' );

		// Hide menu toggle button if menu is empty and return early.
		if ( ! menu ) {
			button.style.display = 'none';
			return;
		}
		menu.classList.add( 'nav-menu' );
	}

	handheldMenu() {
		this.themeToggle('handheld');
		let handheldNavigation = $('.handheld-navigation');
		if (handheldNavigation.length > 0) {
			handheldNavigation.find('.menu-item-has-children > a, .page_item_has_children > a').each((index, element) => {
				let dropdown = $('<button class="dropdown-toggle"></button>');
				dropdown.insertAfter(element);
				dropdown.on('click', function (e) {
					e.preventDefault();
					dropdown.toggleClass('toggled-on');
					dropdown.siblings('ul').stop().slideToggle(400);
				});
			});
		}
	}

	themeToggle($nameToggle) {
		let toggleObject = document.getElementById($nameToggle + '-toggle');
		let toggleOverlay = document.getElementById($nameToggle + '-overlay');
		let toggleClose = document.getElementById($nameToggle + '-close');
		let toggleWrap = document.getElementById($nameToggle + '-wrap');

		if (
			null === toggleObject ||
			null === toggleOverlay ||
			null === toggleClose
		) {
			return;
		}
		document.body.classList.add('has-' + $nameToggle + '-toggle');
		toggleObject.addEventListener('click', function (event) {
			event.preventDefault();
			handheldNavigationVisibility();
		});

		toggleOverlay.addEventListener('click', function (event) {
			handheldNavigationVisibility();
		});

		toggleClose.addEventListener('click', function (event) {
			handheldNavigationVisibility();
		});

		const handheldNavigationVisibility = (event) => {
			toggleWrap.classList.toggle('active');
			toggleOverlay.classList.toggle('active');
			document.body.classList.toggle($nameToggle + '-toggle-active');
			jquery('html').toggleClass('overflow-hidden');
		};
	}

}
new themeActivatelife();
